import React from 'react';

import EditSet from './modals/edit-set.js';
import DeleteSet from './modals/delete-set.js';
import EditTally from './modals/edit-tally.js';
import DeleteTally from './modals/delete-tally.js';
import MoveTally from './modals/move-tally.js';
import EditMark from './modals/edit-mark.js';

export default props => {
	switch (props.selectedModal) {
		case 'ADD-SET':
		case 'EDIT-SET':
			return <EditSet {...props} />;
		case 'DELETE-SET':
			return <DeleteSet {...props} />;

		case 'ADD-TALLY':
		case 'EDIT-TALLY':
			return <EditTally {...props} />;
		case 'DELETE-TALLY':
			return <DeleteTally {...props} />;
		case 'MOVE-TALLY':
			return <MoveTally {...props} />;

		case 'ADD-MARK':
		case 'EDIT-MARK':
			return <EditMark {...props} />;

		default:
			return null;
	}
}


// WEBPACK FOOTER //
// ./src/modal.js